'use client';

import type { ReactNode } from 'react';
import { Box } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';
import { Text } from '../../../../../components/styled/text';
import { ReadOnlyCodeEditor } from '../../ReadOnlyCodeEditor';
import type { HITLContentContext } from '../../tool-config-types';

const SCRIPT_MAX_HEIGHT = '260px';

function CoderHitlContent({
  args,
}: {
  args?: Record<string, unknown>;
}): ReactNode {
  const tCoder = useTranslations('designSystem.chat.coder');

  const script =
    args && typeof args.script === 'string' && args.script.trim().length > 0
      ? args.script
      : undefined;

  if (!script) return null;

  return (
    <Box width="100%">
      <Box
        px={2}
        py={1.5}
        bg="bg.muted"
        borderBottomWidth="1px"
        borderColor="border.default"
        borderTopRadius="md"
      >
        <Text fontSize="xs" fontWeight="medium" color="fg.muted">
          {tCoder('script')}
        </Text>
      </Box>
      <Box
        bg="bg.subtle"
        borderBottomRadius="md"
        overflow="hidden"
        maxHeight={SCRIPT_MAX_HEIGHT}
        overflowY="auto"
      >
        <ReadOnlyCodeEditor
          value={script}
          maxHeight={SCRIPT_MAX_HEIGHT}
          language="python"
        />
      </Box>
    </Box>
  );
}

export const renderCoderHitlContent = (ctx: HITLContentContext): ReactNode => (
  <CoderHitlContent args={ctx.args} />
);
